module.exports = __webpack_public_path__ + "static/media/crearaviso.5e14a6e2.png";